import React from 'react';
import { Terminal, RefreshCw, AlertTriangle, ShieldCheck } from 'lucide-react';
import { useAuth } from '@/services/auth/authContext';

export const AuthLoadingScreen: React.FC = () => {
  const { status, retryBootstrap } = useAuth();
  const isOffline = status === 'OFFLINE_ERROR';

  return (
    <div className="min-h-screen w-full bg-[var(--bg-app)] flex flex-col items-center justify-center p-4 select-none">
      <div className="w-full max-w-md bg-[var(--bg-surface)] border border-[var(--border-default)] rounded-xl p-6 shadow-2xl space-y-6 text-center">
        {/* Terminal Header */}
        <div className="flex items-center justify-center gap-3">
          <div className="p-2.5 rounded-lg bg-emerald-950/80 border border-emerald-800/80 text-emerald-400 shadow-[0_0_16px_rgba(16,185,129,0.25)]">
            <Terminal className="w-6 h-6" />
          </div>
          <div className="text-left">
            <div className="font-mono font-bold text-[var(--text-primary)] text-base tracking-tight">
              TERMINAL // OPS
            </div>
            <p className="text-[10px] font-mono text-[var(--text-muted)]">
              Swing & Delivery Stock Trading Bot
            </p>
          </div>
        </div>

        <div className="h-px w-full bg-[var(--border-default)]" />

        {/* State details */}
        {!isOffline ? (
          <div className="space-y-4 py-4">
            <div className="flex justify-center">
              <RefreshCw className="w-8 h-8 text-emerald-400 animate-spin" />
            </div>
            <div className="space-y-1">
              <p className="text-xs font-mono font-semibold text-[var(--text-secondary)]">
                BOOTSTRAPPING OPERATOR SESSION
              </p>
              <p className="text-[11px] font-mono text-[var(--text-muted)]">
                Verifying secure session credentials with backend...
              </p>
            </div>
          </div>
        ) : (
          <div className="space-y-4 py-2">
            <div className="flex justify-center">
              <div className="p-3 rounded-full bg-amber-950/60 border border-amber-800/60 text-amber-400">
                <AlertTriangle className="w-8 h-8" />
              </div>
            </div>
            <div className="space-y-1">
              <p className="text-xs font-mono font-semibold text-amber-300">
                BACKEND UNREACHABLE
              </p>
              <p className="text-[11px] font-mono text-[var(--text-muted)]">
                Unable to verify session with the server. Please check your internet connection or backend availability.
              </p>
            </div>
            <button
              onClick={() => retryBootstrap()}
              className="w-full flex items-center justify-center gap-2 px-4 py-2.5 rounded-md bg-emerald-600 hover:bg-emerald-500 active:bg-emerald-700 text-white font-mono text-xs font-semibold transition-all duration-150 active:scale-[0.98] shadow-lg shadow-emerald-950/50"
            >
              <RefreshCw className="w-3.5 h-3.5" />
              <span>Retry Connection</span>
            </button>
          </div>
        )}

        {/* Footer info */}
        <div className="pt-2 border-t border-[var(--border-default)] flex items-center justify-between text-[10px] font-mono text-[var(--text-dim)]">
          <span className="flex items-center gap-1">
            <ShieldCheck className="w-3.5 h-3.5 text-[var(--text-muted)]" />
            Zero-Token Storage (HttpOnly)
          </span>
          <span>v1.0.0</span>
        </div>
      </div>
    </div>
  );
};
